



































import {
  IQuoteVentilationRoomFieldError,
  QuoteVentilationRoomFieldError
} from '@/models';
import mixins from '@/utils/mixins';
import Validatable from '@/mixins/validatable';
import BindsAttrs from '@/mixins/binds-attrs';
import Messages from '../common/Messages.vue';
import QuillPDFEditor from '../common/QuillPDFEditor.vue';

const baseMixins = mixins(BindsAttrs, Validatable);
import { InputMessage, InputValidationRules } from 'vuetify/types';

interface Options extends InstanceType<typeof baseMixins> {
  /* eslint-disable-next-line camelcase */
  $_modelEvent: string;
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    components: { Messages, QuillPDFEditor },
    name: 'QuoteVentilationRoomCard',
    props: {
      clearable: Boolean,
      color: { type: String, default: 'primary' },

      roomNum: {
        type: Number,
        required: true
      },

      fieldError: {
        type: Object as () => IQuoteVentilationRoomFieldError,
        default: () => new QuoteVentilationRoomFieldError()
      }
    },

    data: () => ({
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'link'],
            [{ list: 'ordered' }, { list: 'bullet' }]
          ]
        }
      }
    }),

    computed: {
      //override internalErrormessage to display fielderror messages
      internalErrorMessages(): InputValidationRules {
        return this.genInternalMessages(this.errorMessages).concat(
          this.genInternalMessages(this.fieldError.description as InputMessage)
        );
      }
    },

    methods: {
      deleteRoom() {
        this.$emit('delete:room', this.internalValue);
      },

      clearErrors() {
        this.fieldError.clearErrors();
        this.$emit('clearErrors');
      },

      clearableCallback() {
        this.internalValue.description = '';
      }
    }
  });
